import { eUserType } from "../helpers/udmConstants";

export const generateUser = (
    type = eUserType.advisor
) => {
    return { type };
};